// extracted by mini-css-extract-plugin
export var addressFields = "_nl-0";
export var animationContainer = "_nl-1";
export var footer = "_nl-2";
export var lineItems = "_nl-3";
export var modalContent = "_nl-4";
export var orderName = "_nl-5";
export var strong = "_nl-6";
export var warning = "_nl-7";